module.exports = "/images/complete-form.png?c64401bb40fb250e4978c73c5f867df1";